// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1pfhoahv{margin-block-start:var(--ds-space-600,3pc)}
._6rthoahv{margin-block-end:var(--ds-space-600,3pc)}
._y3gn1h6o{text-align:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-picker/dist/esm/common/ui/empty-state/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,0CAA0C;AACrD,WAAW,wCAAwC;AACnD,WAAW,iBAAiB","sourcesContent":["._1pfhoahv{margin-block-start:var(--ds-space-600,3pc)}\n._6rthoahv{margin-block-end:var(--ds-space-600,3pc)}\n._y3gn1h6o{text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
